import { render, staticRenderFns } from "./GeneralIndicators.vue?vue&type=template&id=404c7526"
import script from "./GeneralIndicators.vue?vue&type=script&lang=js"
export * from "./GeneralIndicators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports